import { joinSearchQuery } from '../../../libs/queryString';
import { parseQuery, stringifyQuery } from './queryParams';
import { RouteLocation } from './createRoute';

export interface SortFiltersParams {
  sortCategorySlug: string | null;
}

export function isLocationsSame(first: RouteLocation, second: RouteLocation) {
  return first.pathname === second.pathname && joinSearchQuery(first.search) === joinSearchQuery(second.search);
}

export function parseSortFiltersSearchQuery(search?: string): SortFiltersParams {
  const { sort } = parseQuery(search);

  return { sortCategorySlug: sort ? sort : null };
}

export function buildSortFilterSearchQuery(params: Partial<SortFiltersParams>): string {
  const { sortCategorySlug } = params;

  const query = { sort: sortCategorySlug === null ? undefined : sortCategorySlug };

  return stringifyQuery(query);
}
